import styled from 'styled-components'

const Intents = styled.div`
  overflow-y: auto;
  height: 100%;
`

export { Intents }
